'use client'

import React from 'react'

type Props = {
    numSides: number
    sideLength: number
}

const WIDTH = 340
const HEIGHT = 220

// Math.cos/sin aren't guaranteed bit-identical between Node (SSR) and the
// browser (CSR) - rounding coordinates avoids a hydration mismatch from a
// 1-ULP-different float producing a different toString() on each side.
const r2 = (n: number) => Math.round(n * 100) / 100

export default function RegularPolygonChart({ numSides, sideLength }: Props) {
    const n = Math.min(Math.max(Math.round(numSides) || 3, 3), 100)
    const r = 85
    const cx = WIDTH / 2
    const cy = HEIGHT / 2 + 5

    const points: string[] = []
    for (let i = 0; i < n; i++) {
        const angle = -Math.PI / 2 + (2 * Math.PI * i) / n
        const x = r2(cx + r * Math.cos(angle))
        const y = r2(cy + r * Math.sin(angle))
        points.push(`${x},${y}`)
    }

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            <polygon points={points.join(' ')} fill="#2563eb" opacity={0.18} stroke="#2563eb" strokeWidth={2} />
            <text x={cx} y={cy - r - 12} fontSize={12} textAnchor="middle" fill="#374151">
                n = {n}, s = {sideLength.toFixed(2)}
            </text>
        </svg>
    )
}
